// extracted by mini-css-extract-plugin
export default {"container":"Error404_container__KnACy","text":"Error404_text__EYZDq"};